import * as React from 'react';
// @ts-ignore
import { REQUESTER_ROLE_OPTIONS } from 'admin/constants/AdminUpgrade';
// @ts-ignore
import { saveLocalQuoteField, ORG_TYPE_STRING } from 'admin/reducers/adminUpgradePage';
import assertions from 'lib/assertions';
import Columns2 from 'components/Columns2';
// @ts-ignore
import { regionsForCountry, stateIsValid, countryIsValid } from 'lib/geo/Country';
import EventTracking from 'lib/EventTracking';
import FormElement from 'components/FormElement';
import Heading from 'components/Heading';
import Input from 'components/Input';
// @ts-ignore
import InputValueConstants from 'constants/InputValueConstants';
import Link from 'components/Link';
import Notice from 'components/Notice';
// @ts-ignore
import OrganizationPicker from 'components/OrganizationPicker';
import PhoneNumberMaskedInput from 'components/PhoneNumberMaskedInput';
import Row from 'components/Row';
import Select from 'components/Select';
import Text from 'components/Text';
// @ts-ignore
import AdminUpgradeTitle from 'admin/components/AdminUpgradeTitle';
import AdminUpgradeStatsContainer from 'admin/components/AdminUpgradeStats';
import AdminUpgradeFeatures from 'admin/components/AdminUpgradeFeatures/AdminUpgradeFeatures';
import Button from 'components/Button';
// @ts-ignore
import User from 'entities/User';
import { UpgradePlanData } from 'admin/components/AdminUpgradePlan/AdminUpgradePlanContainer';

import '../styles/AdminUpgradePlanOrganizationInfoForm.scss';
import '../styles/AdminUpgradePageView.scss';

type Props = {
  onPersistState: (fields: UpgradePlanData, onSuccess: Function) => void,
  onAdvance: () => void,
  onSelectSchool?: (uuid: String) => void,
  organizationUuid?: string, // TODO: Don't forget to do something about this
  orgTypeString?: string,
};

type State = {
  country?: string;
  state?: string;
  city?: string;
  orgUuid?: string;
  lat?: number;
  long?: number;
  teachersCount?: number;
  studentsCount?: number;
  comment?: string
  requesterFirstName?: string;
  requesterLastName?: string;
  role?: string;
  phoneNumber?: string;
  requesterEmail?: string;
};

class AdminUpgradePlanOrganizationInfoForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      orgUuid: props.organizationUuid
    };
  }


  track = (key: string) => {
    const organization_uuid = this.props.organizationUuid || null;
    EventTracking.trackKey(
      `admin_self_serve.v2.organization_info_page.${key}`,
      {
        organization_uuid,
      }
    );
  };


  canSubmit = () => {
    const fieldValues: { [key: string]: any } = { ...this.state }
    let canBeSubmitted: boolean = true;
    const getKeyValue = <U extends keyof T, T extends object>(obj: T) => (key: U) => obj[key];
    for (let k in fieldValues) {
      canBeSubmitted = canBeSubmitted && getKeyValue(fieldValues)(k) !== undefined;
    }

    return canBeSubmitted;
  }

  buttonOnClick() {
    const { onPersistState, onAdvance } = this.props;
    this.canSubmit() && onPersistState(this.state as UpgradePlanData, onAdvance);
  }

  renderSidebar() {
    const orgUuid = this.props.organizationUuid;
    return orgUuid ? (
      <AdminUpgradeStatsContainer
        organizationUuid={orgUuid}
        onNoStats={() => { }}
      />
    ) : (
        <AdminUpgradeFeatures />
      );
  }

  render() {
    const { onSelectSchool, orgTypeString } = this.props;

    return (
      <div className="AdminUpgradePageView AdminUpgradePlanOrganizationInfoForm">
        <div className="AdminUpgradePageView-content-body">
          <div className="AdminUpgradePageView-content-body-forms">
            <Row>
              <Text weight="semibold" size="xlarge" element="div">
                Tell us about your organization
              </Text>
              <Text size="medium" element="div">
                Find or add your school, district, university, or other organization.
              </Text>
            </Row>
            <FormElement
              label={'Organization name'}
              onValidChange={o => {
                this.track('select_school.click');
                if (o.country && countryIsValid(o.country)) {
                  this.setState({ country: o.country });
                }
                if (o.state && stateIsValid(o.state, o.country)) {
                  this.setState({ state: o.state });
                }
                if (o.city) {
                  this.setState({ city: o.city });
                }

                this.setState({
                  orgUuid: o.orgUuid,
                  lat: o.latitude,
                  long: o.longitude
                });

                if (orgTypeString === 'school' && onSelectSchool) {
                  onSelectSchool(o.uuid);
                }
              }}
              element={OrganizationPicker}
              elementProps={{
                type: orgTypeString,
                onClickInteraction: () => this.track('school_picker.click'),
                initialOrganizationUuid: this.props.organizationUuid,
              }}
            />
            <Columns2>
              <FormElement
                label="Estimated teachers on staff"
                validate={e => {
                  assertions.number(e.target.value);
                  assertions.positiveNumber(e.target.value);
                  assertions.integer(e.target.value);
                  assertions.signedInt32(Number(e.target.value));
                }}
                onValidChange={e => this.setState({ teachersCount: e.target.value })}
                onInvalidChange={() => this.setState({ teachersCount: undefined })}
                element={Input}
                elementProps={{
                  onFocus: () => this.track('teachers_on_staff.click'),
                  value: this.state.teachersCount,
                  'data-test-selector': 'est-teachers-input',
                }}
              />
              <FormElement
                label="Estimated student enrollment"
                validate={e => {
                  assertions.number(e.target.value);
                  assertions.positiveNumber(e.target.value);
                  assertions.integer(e.target.value);
                  assertions.signedInt32(Number(e.target.value));
                  assertions.valueGreaterThan(
                    5,
                    e.target.value,
                    'Must include more than five people'
                  );
                }}
                onValidChange={e => this.setState({ studentsCount: e.target.value })}
                onInvalidChange={() => this.setState({ studentsCount: undefined })}
                element={Input}
                elementProps={{
                  onFocus: () => this.track('student_enrollment.click'),
                  value: this.state.studentsCount,
                  'data-test-selector': 'est-students-input',
                }}
              />
            </Columns2>
            <Row size="small">
              <FormElement
                label={<span>Why Are you interested in the Remind plan?</span>}
                onValidChange={e => this.setState({ comment: e.target.value })}
                onInvalidChange={() => this.setState({ comment: undefined })}
                element={Input}
                elementProps={{
                  value: this.state.comment,
                  onFocus: () => this.track('details.click'),
                  placeholder:
                    "Let us know why you're considering Remind and any questions you might have.",
                }}
              />
            </Row>

            <section className="AdminUpgradePlanDefinitionForm-about">
              <Row size="small">
                <Heading level="2" levelStyle="5">
                  <Text size="medium" weight="light" color="eclipse">
                    About you
                  </Text>
                </Heading>
              </Row>
              <Columns2>
                <FormElement
                  label="First name"
                  validate={e => {
                    assertions.notEmpty(e.target.value);
                    assertions.lengthLesserThanOrEqualTo(
                      e.target.value,
                      InputValueConstants.FIRST_NAME_LENGTH
                    );
                  }}
                  onValidChange={e => this.setState({ requesterFirstName: e.target.value })}
                  onInvalidChange={() => this.setState({ requesterFirstName: undefined })}
                  element={Input}
                  elementProps={{
                    onFocus: () => this.track('requester_first_name.click'),
                    'data-test-selector': 'first-name-input',
                  }}
                />
                <FormElement
                  label="Last name"
                  validate={e => {
                    assertions.notEmpty(e.target.value);
                    assertions.lengthLesserThanOrEqualTo(
                      e.target.value,
                      InputValueConstants.LAST_NAME_LENGTH
                    );
                  }}
                  onValidChange={e => this.setState({ requesterLastName: e.target.value })}
                  onInvalidChange={() => this.setState({ requesterLastName: undefined })}
                  element={Input}
                  elementProps={{
                    onFocus: () => this.track('requester_last_name.click'),
                    'data-test-selector': 'last-name-input',
                  }}
                />
              </Columns2>
              <Columns2>
                <FormElement
                  label="Role"
                  validate={role => {
                    assertions.notEmpty(role);
                  }}
                  onValidChange={role => {
                    this.setState({ role: role });
                  }}
                  onInvalidChange={() => this.setState({ role: undefined })}
                  element={Select}
                  elementProps={{
                    onFocus: () => this.track('requester_role.click'),
                    options: REQUESTER_ROLE_OPTIONS,
                    placeholder: 'Select...',
                    value: this.state.role,
                    className: 'AdminUpgradePlanDefinitionForm-rolePicker',
                  }}
                />
              </Columns2>
              <Columns2>
                <FormElement
                  label="Phone number"
                  validate={e => {
                    assertions.number(e.raw, 'Invalid phone number.');
                    assertions.completePhoneNumber(e.raw, 'Invalid phone number.');
                  }}
                  onValidChange={e => this.setState({ phoneNumber: e.raw })}
                  onInvalidChange={() =>
                    this.setState({ phoneNumber: undefined })
                  }
                  element={PhoneNumberMaskedInput}
                  elementProps={{
                    onFocus: () => this.track('requester_phone_number.click'),
                    'data-test-selector': 'phone-number-input',
                  }}
                />
                <FormElement
                  label="Work email address"
                  validate={e => {
                    assertions.email(e.target.value);
                    assertions.notEmpty(e.target.value);
                  }}
                  onValidChange={e =>
                    this.setState({ requesterEmail: e.raw })
                  }
                  onInvalidChange={() =>
                    this.setState({ requesterEmail: undefined })
                  }
                  element={Input}
                  elementProps={{
                    onFocus: () => this.track('requester_email.click'),
                    'data-test-selector': 'email-input',
                  }}
                />
              </Columns2>
              <Columns2>
                <Button disabled={!this.canSubmit()} onClick={this.buttonOnClick}>Submit</Button>
              </Columns2>
            </section>
          </div>
          <div className="AdminUpgradePageView-content-body--desktop-side">
            <Row size="xxxlarge">{this.renderSidebar()}</Row>
          </div>
        </div>

        {this.state.studentsCount && this.state.studentsCount <= 5 && (
          <Row size="xxxlarge">
            <Notice color="polar-bear" noShadow data-test="student-enrollment-too-small">
              <Text size="xsmall">
                Remind plans are only available for schools and districts, but you can always start
                with an individual account! Click <Link to="/">here</Link> to sign up for free.
              </Text>
            </Notice>
          </Row>
        )}
      </div>
    );
  }
}


export { AdminUpgradePlanOrganizationInfoForm };
export default AdminUpgradePlanOrganizationInfoForm;
